import React, { useEffect, useState } from 'react'
import ArticleView from 'components_v2/SupportPages/ArticleView'
import { useParams } from 'react-router-dom'
import { axios } from 'api'
import { useCommonEntryContext } from 'components_v2/common'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
import { SUPPORT_DESCRIPTION } from './SupportView'

const ArticleItemView = () => {
  const { category, slug } = useParams()
  const [propMap, setPropsMap] = useState({})
  const currentProp = propMap[slug]
  const { setNotFound } = useCommonEntryContext()
  useTitle('FAQ')
  useMeta([
    {
      name: 'description',
      content: SUPPORT_DESCRIPTION
    }
  ])
  useEffect(() => {
    if (currentProp) return
    axios
      .get(`/support/list?category=${category}&slug=${slug}`)
      .then((res) => {
        setPropsMap((state) => ({ ...state, [slug]: res.data }))
        setNotFound(!Boolean(res.data?.article))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [category, slug, currentProp, setNotFound])
  if (!currentProp) return null
  return (
    <ArticleView
      category={category}
      slug={slug}
      articleList={currentProp?.list || []}
      article={currentProp?.article}
    />
  )
}

export default ArticleItemView
